(() => {
  if (window.dsLowestPriceTooltipInitialized) return;
  window.dsLowestPriceTooltipInitialized = true;

  const rootSelector = '[data-lowest-price-tooltip]';
  const triggerSelector = '[data-lowest-price-tooltip-trigger]';
  let tooltipId = 0;
  let pointerTrigger = null;

  const prepare = (root) => {
    const trigger = root?.querySelector(triggerSelector);
    const tooltip = root?.querySelector('[data-lowest-price-tooltip-content]');
    if (!trigger || !tooltip) return null;

    if (!tooltip.id) {
      tooltipId += 1;
      tooltip.id = `ds-lowest-price-tooltip-${tooltipId}`;
      trigger.setAttribute('aria-describedby', tooltip.id);
    }

    return { trigger, tooltip };
  };

  const position = (root, tooltip) => {
    root.style.setProperty('--ds-lowest-price-shift', '0px');
    const rect = tooltip.getBoundingClientRect();
    const gutter = 12;
    let shift = 0;

    if (rect.left < gutter) shift = gutter - rect.left;
    if (rect.right + shift > window.innerWidth - gutter) {
      shift -= rect.right + shift - (window.innerWidth - gutter);
    }

    root.style.setProperty('--ds-lowest-price-shift', `${Math.round(shift)}px`);
  };

  const open = (root) => {
    const elements = prepare(root);
    if (!elements) return;

    root.classList.add('is-open');
    elements.trigger.setAttribute('aria-expanded', 'true');
    elements.tooltip.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => position(root, elements.tooltip));
  };

  const close = (root) => {
    const elements = prepare(root);
    if (!elements) return;

    root.classList.remove('is-open');
    elements.trigger.setAttribute('aria-expanded', 'false');
    elements.tooltip.setAttribute('aria-hidden', 'true');
    root.style.setProperty('--ds-lowest-price-shift', '0px');
  };

  const closeOthers = (except) => {
    document.querySelectorAll(`${rootSelector}.is-open`).forEach((root) => {
      if (root !== except) close(root);
    });
  };

  document.querySelectorAll(rootSelector).forEach(prepare);

  document.addEventListener('pointerdown', (event) => {
    pointerTrigger = event.target.closest(triggerSelector);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);

    if (!trigger) {
      closeOthers(null);
      pointerTrigger = null;
      return;
    }

    event.preventDefault();
    const root = trigger.closest(rootSelector);

    // Keyboard focus itself opens the tooltip; Enter/Space should keep it open.
    if (trigger !== pointerTrigger) {
      closeOthers(root);
      open(root);
      return;
    }

    const shouldOpen = !root.classList.contains('is-open');
    closeOthers(root);
    if (shouldOpen) open(root);
    else close(root);
    pointerTrigger = null;
  });

  document.addEventListener('focusin', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger || trigger === pointerTrigger) return;
    const root = trigger.closest(rootSelector);
    closeOthers(root);
    open(root);
  });

  document.addEventListener('focusout', (event) => {
    const root = event.target.closest(rootSelector);
    if (!root) return;
    requestAnimationFrame(() => {
      if (!root.contains(document.activeElement)) close(root);
    });
  });

  document.addEventListener('pointerover', (event) => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const root = event.target.closest(rootSelector);
    if (!root || root.contains(event.relatedTarget)) return;
    const elements = prepare(root);
    if (elements) requestAnimationFrame(() => position(root, elements.tooltip));
  });

  document.addEventListener('pointerout', (event) => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const root = event.target.closest(rootSelector);
    const trigger = root?.querySelector(triggerSelector);
    if (!root || root.contains(event.relatedTarget) || trigger?.matches(':focus-visible')) return;
    close(root);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest(rootSelector);
    if (!root) return;
    close(root);
    root.querySelector(triggerSelector)?.blur();
  });
})();
